import { Button, ControlGroup, Tag } from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import React from "react";
import { apiCallPost, niceDate } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import { DateRangeInput } from "@blueprintjs/datetime";
import moment from "moment";

class SxReportTopBar extends React.Component {
  today = moment().startOf("day").toDate();
  state = {
    site: null,
    createdInStart: this.today,
    createdInEnd: this.today,
  };
  getData = async () => {
    let obj = {};
    if (this.state.site) {
      obj["site"] = this.state.site;
    }
    if (!this.state.createdInStart && this.state.createdInEnd) {
      cogoToast.error("You need to put in both start and end intervals.");
      return;
    }

    if (this.state.createdInStart && !this.state.createdInEnd) {
      cogoToast.error("You need to put in both start and end intervals.");
      return;
    }
    if (this.state.createdInStart) {
      obj["onDayRange"] = [this.state.createdInStart, this.state.createdInEnd];
    }
    try {
      cogoToast.loading("Searching...");
      this.setState({ isSearching: true });
      let res = await apiCallPost(
        `/booking-sx/${this.props.authStore.prefix}/sxBooking/report/${
          this.props.entityType == "sxBookingRegisterReport"
            ? "sxBookingReport"
            : this.props.entityType
        }/`,
        obj
      );
      this.props.onDataLoad(res);
      this.setState({ isSearching: false });
      cogoToast.success("Search completed.");
    } catch (err) {
      this.setState({ isSearching: false });

      cogoToast.error("We ran into an error while searching.");
    }
  };

  renderItemControls = () => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <ControlGroup>
          <Tag large minimal>
            Site
          </Tag>
          <SingleSelectWrapper
            items={this.props.sites}
            showSelectProp={true}
            selectedItem={this.state.site}
            onChange={(site) => this.setState({ site: site })}
          />
        </ControlGroup>
        <ControlGroup>
          {/* <Tag
            minimal
            interactive
            onRemove={() =>
              this.setState({ createdInEnd: null, createdInStart: null })
            }
          >
            Date Range
          </Tag>
          <DateInput
            inputProps={{ style: { width: "8em" } }}
            value={
              this.state.createdInStart
                ? new Date(this.state.createdInStart)
                : null
            }
            formatDate={(date) => niceDate(new Date(date))}
            parseDate={(str) => new Date(str)}
            onChange={(value) => {
              this.setState({ createdInStart: new Date(value) });
            }}
            placeholder="From"
          />
          <Tag minimal icon="arrow-right"></Tag>{" "}
          <DateInput
            inputProps={{ style: { width: "8em" } }}
            value={
              this.state.createdInEnd ? new Date(this.state.createdInEnd) : null
            }
            formatDate={(date) => niceDate(new Date(date))}
            parseDate={(str) => new Date(str)}
            onChange={(value) => {
              this.setState({ createdInEnd: new Date(value) });
            }}
            placeholder="To"
          /> */}
          <Tag
            large
            minimal
            onRemove={() => {
              this.setState({ createdInEnd: null, createdInStart: null });
            }}
          >
            Date Range:
          </Tag>
          <DateRangeInput
            value={
              this.state.createdInStart
                ? [this.state.createdInStart, this.state.createdInEnd]
                : null
            }
            formatDate={(date) => niceDate(date)}
            parseDate={(str) => new Date(str)}
            minDate={new Date(2021, 0, 1)}
            maxDate={new Date(2030, 0, 1)}
            allowSingleDayRange
            contiguousCalendarMonths={false}
            onChange={(value) =>
              this.setState({
                createdInStart: value[0],
                createdInEnd: value[1],
              })
            }
          />
        </ControlGroup>
        <Button
          icon="search"
          intent="success"
          loading={this.state.isSearching}
          onClick={() => this.getData()}
        />
      </div>
    );
  };
  render() {
    return <>{this.renderItemControls()}</>;
  }
}

export default inject("authStore")(observer(SxReportTopBar));
